<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand pt-2"
    :class="{'bg-danger navbar-dark': type === 'default'}"
  >
    <b-alert variant="danger" show v-if="observatory" class="py-2 px-3 mt-3 position-absolute">Observing {{ observed.name }}'s ClarityNOW</b-alert>
    <!-- Navbar links -->
    <b-navbar-nav class=" align-items-center ml-md-auto">
      <!-- This item dont have <b-nav-item> because they add class 'nav-link' which is not needed here -->
      <li class="nav-item d-xl-none">
        <!-- Sidenav toggler -->
        <div class="pr-3 sidenav-toggler"
             :class="{active: $sidebar.showSidebar, 'sidenav-toggler-dark': type === 'default', 'sidenav-toggler-light': type === 'light'}"
             @click="toggleSidebar">
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
    </b-navbar-nav>
    <b-navbar-nav class="align-items-center ml-auto ml-md-0">
      <a class="nav-link" href="/home">
        <i class="fas fa-home"></i>
      </a>
      <base-dropdown class="nav-item"
                     tag="li"
                     title-classes="nav-link"
                     title-tag="a"
                     :icon="notifications.length > 0 ? 'fas fa-bell fa-beat-fade' : 'fas fa-bell'"
                     menu-classes="dropdown-menu-xl dropdown-menu-right py-0 overflow-hidden">
        <template>
          <!-- Dropdown header -->
          <div class="px-3 py-3">
            <h6 class="text-sm text-muted m-0">You have <strong class="text-primary">{{ notifications.length }}</strong> notifications.</h6>
          </div>
          <!-- List group -->
          <b-list-group flush>
            <b-list-group-item action :to="'/notifications/' + notification.id" v-for="(notification, index) in notifications" :key="index">
              <b-row align-v="center">
                <b-col>
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h4 class="mb-0 text-sm">{{ notification.data.from }}</h4>
                    </div>
                    <div class="text-right text-muted">
                      <small>{{ new Date(notification.created_at) | date('M/d/Y h:mm a') }}</small>
                    </div>
                  </div>
                  <p class="text-sm mb-0">{{ notification.data.subject }}</p>
                </b-col>
              </b-row>
            </b-list-group-item>
          </b-list-group>
          <!-- View all -->
          <!-- This item dont have <b-dropdown-item> because item have styles " text-center text-primary font-weight-bold py-3" on tag <a> wich we cant add -->
          <b-link href="#" to="/notifications" class="dropdown-item text-center text-primary font-weight-bold py-3">View all</b-link>
        </template>
      </base-dropdown>
      <base-dropdown menu-on-right
                     class="nav-item"
                     tag="li"
                     title-tag="a"
                     title-classes="nav-link pr-0">
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <b-media no-body class="align-items-center">
            <avatar :name="userName" :avatar="avatar"></avatar>
            <b-media-body class="ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm  font-weight-bold">{{ userName }}</span>
            </b-media-body>
          </b-media>
        </a>

        <template>

          <b-dropdown-header class="noti-title">
            <h6 class="text-overflow m-0">Welcome!</h6>
          </b-dropdown-header>
          <b-dropdown-item @click="goToAccount">
            <i class="fas fa-cog"></i>
            <span>Account Settings</span>
          </b-dropdown-item>
          <div class="dropdown-divider"></div>
          <b-dropdown-item @click.prevent="logout()">
            <i class="ni ni-user-run"></i>
            <span>Logout</span>
          </b-dropdown-item>

        </template>
      </base-dropdown>
    </b-navbar-nav>
  </base-nav>
</template>
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { BaseNav } from '@/components';
import Avatar from '@/views/Components/Avatar';

export default {
  components: {
    BaseNav,
    Avatar
  },
  props: {
    type: {
      type: String,
      default: 'default', // default|light
      description: 'Look of the dashboard navbar. Default (Green) or light (gray)'
    }
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: '',
    };
  },
  computed: {
    ...mapGetters({
      user: 'profile/user',
      userRoute: 'profile/userRoute',
      avatar: 'profile/avatar',
      observed: 'observed/observed',
      notifications: 'notifications/notifications'
    }),
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    userName() {
      return this.user.name;
    },
    userEmail() {
      return this.user.email;
    },
    userSlug() {
      return this.user.slug;
    },
    observatory() {
      return this.$route.meta.observatory;
    }
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    goToAccount() {
      if(this.$route.name !== 'Account') {
        this.$router.push({
          path: '/account-settings'
        });
      }
    },
    async logout() {
      axios.post(process.env.VUE_APP_API_BASE_URL + "/logout")
      .then(response => {
        if(response.status == 200) {
          this.$store.dispatch("logout", {email: this.userEmail});
        }
      })
      .catch(error => {

      });
    },
  },
  created() {
    this.$store.dispatch("notifications/get", { user: this.userSlug });
  }
};
</script>
